<template>
  <!-- <v-tooltip bottom :disabled="tooltip_disabled"> -->
  <!-- <template v-slot:activator="{ on, attrs }"> -->
  <!-- <div v-bind="attrs" v-on="on"> -->
  <div>
    <router-link :to="{ name: toName }" class="allSettingItem" :class="customClass">
      <div class="icon">
        <BaseIcon :icon="icon" />
      </div>
      <span class="text f16">
        {{ text }}
      </span>
    </router-link>
  </div>
  <!-- </template> -->
  <!-- <span>{{ text }}</span>
    </v-tooltip> -->
</template>

<script>
export default {
  name: 'AllSetingItem',
  props: {
    text: String,
    toName: String,
    icon: String,
    customClass: String,
    tooltip_disabled: Boolean,
  },
  data: () => ({}),
}
</script>

<style lang="scss" scoped>
div {
  width: 100%;
  height: 100%;
}
:deep().allSettingItem {
  display: grid;
  grid-template-columns: max-content auto;
  grid-column-gap: 15px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 20px;
  text-decoration: none;
  transition: all 0.3s;
  align-items: center;
  max-height: 80px;
  .icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #6ab1d8;
    display: grid;
    align-content: center;
    justify-content: center;
    svg {
      max-width: 20px;
      max-height: 20px;
      height: auto;
      path {
        fill: #ffffff;
      }
    }
  }
  .text {
    display: flex;
    align-items: center;
    line-height: 19px;
    color: #2c2c2c;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &.line2 {
    background: #fafafa;
  }
  &.line3 {
    background: #f2f2f2;
    border: 1px solid #d1d1d1;
  }
  &:hover {
    background: #277faf;
    .icon {
      background: #ffffff;
      svg {
        path {
          fill: #277faf;
        }
      }
    }
    .text {
      color: #ffffff;
    }
  }
}
</style>
